var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriorityIconNavigation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.6 24.1c-6.9-6.9-16.1-10.7-25.9-10.7s-19 3.8-25.9 10.7S13.1 40.2 13.1 50s3.8 19 10.7 25.9 16.1 10.7 25.9 10.7 19-3.8 25.9-10.7c14.3-14.3 14.3-37.5 0-51.7Zm-2.1 49.7c-6.3 6.3-14.8 9.8-23.8 9.8s-17.4-3.5-23.8-9.8S16.1 59 16.1 50s3.5-17.4 9.8-23.8 14.8-9.8 23.8-9.8 17.4 3.5 23.8 9.8c13.1 13.1 13.1 34.4 0 47.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m63.4 32.4-33 15.5c-1.1.5-1.8 1.6-1.7 2.9 0 1.2.9 2.3 2 2.6l11.7 3.9L46.3 69c.4 1.2 1.4 2 2.6 2.1h.2c1.2 0 2.2-.7 2.7-1.7l15.5-33c.5-1.1.3-2.5-.6-3.4-.9-.9-2.2-1.1-3.4-.6ZM49.1 68.1 44.7 55l-13.1-4.3 33-15.5-15.5 33Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorityIconNavigation);
export default __webpack_public_path__ + "static/media/priority_icon_navigation.d5052355938870951e1af5274ef83f81.svg";
export { ForwardRef as ReactComponent };